module.exports = __webpack_public_path__ + "img/logo-web.6c1474bd.png";